import ImageBuddy from 'imagebuddy';
import { getAgeKeyFromCookie } from '../util/cookies';
import SiteEvents from '../util/site-events';

class BlockTimelineSlider {
	constructor($block, Swiper) {
		this.$block = $block;
		this.blockEl = this.$block.get(0);
		this.$swiperContainer = this.$block.find('.swiper-container').first();

		const ageKey = getAgeKeyFromCookie();
		const slideEls = Array.from(this.blockEl.querySelectorAll('.swiper-slide'));

		// un-hide the age appropriate image for each slide
		slideEls.forEach((slideEl) => {
			const ageImageEl = slideEl.querySelector(
				`.timeline-block-slider__image[data-age="${ageKey}"]`
			);

			if (ageImageEl) {
				// age specific image has been found
				ageImageEl.classList.remove('hide');
			} else {
				// no age specific image was found; un-hide the default image
				const defaultImageEl = slideEl.querySelector(
					'.timeline-block-slider__image[data-age="default"]'
				);

				if (defaultImageEl) {
					defaultImageEl.classList.remove('hide');
				}
			}
		});

		ImageBuddy.on('image-loaded', (imgEl) => {
			if (jQuery.contains(this.$swiperContainer.get(0), imgEl) && this.swiperInstance) {
				this.swiperInstance.update();
			}
		});

		this.swiperInstance = new Swiper(this.$swiperContainer.get(0), {
			speed: 400,
			slidesPerView: 'auto',
			direction: 'horizontal',
			navigation: {
				prevEl: this.$block.find('.swiper-button-prev').first().get(0),
				nextEl: this.$block.find('.swiper-button-next').first().get(0)
			},
			loop: true,
			autoHeight: this.$swiperContainer
				.parents('.timeline-block-slider')
				.first()
				.hasClass('timeline-block-container--alignment-full'),
			on: {
				init: function () {
					SiteEvents.imageBuddyUpdate();
				}
			}
		});
	}
}

export default BlockTimelineSlider;
